import React, { useState } from "react";
import "./Navbar.css";
import { Dialog, DialogContent, DialogActions, TextField, Button, Typography } from "@mui/material";
import { FaRegHandPointer } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { NewsletterService } from '@df/api';

const Navbar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [subscribeOpen, setSubscribeOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalStatus, setModalStatus] = useState(null); // 'success' | 'error'

  const navigate = useNavigate();

  // Handle Lantern button click
  const handleLanternClick = (e) => {
    e.preventDefault();
    navigate('/login', { state: { from: '/datahub' } });
  };

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      setModalStatus('error');
      setModalMessage('Please enter a valid email address.');
      setModalOpen(true);
      return;
    }
    setLoading(true);
    try {
      const data = await NewsletterService.subscribe(email);
      setModalStatus('success');
      setModalMessage(data.message || 'Subscribed successfully!');
      setEmail("");
      setSubscribeOpen(false);
    } catch (err) {
      setModalStatus('error');
      setModalMessage('Network error. Please try again.');
    } finally {
      setLoading(false);
      setModalOpen(true);
    }
  };

  return (
    <nav className="navbar" id="navbar">
      <div className="logo">
        <a href="/" className="active"><img src="/White logo - no background.png" alt="Datafre8 Logo" /></a>
      </div>
      <ul className="nav-links">
        <li><Link to="/" className={currentPath === '/' ? "active" : ''}>Home</Link></li>
        <li><Link to="/solutions" className={currentPath === '/solutions' ? "active" : ''}>Solutions</Link></li>
        <li><Link to="/ecosystem" className={currentPath === '/ecosystem' ? "active" : ''}>Ecosystem</Link></li>
        <li><Link to="/3rd-axis-academy" className={currentPath === '/3rd-axis-academy' ? "active" : ''}>Academy</Link></li>
        <li><Link to="/contact-us" className={currentPath === '/contact-us' ? "active" : ''}>Pricing</Link></li>
      </ul>
      <div className="nav-right">
        <div className="lantern-link">
          <a href="#" onClick={handleLanternClick} className={currentPath.startsWith('/datahub') ? "active" : ''}>Log in</a>
        </div>
        <div className="subscribe" style={{ position: 'relative' }}>
          <span onClick={() => setSubscribeOpen((prev) => !prev)} style={{ cursor: "pointer" }}>
            Subscribe <FaRegHandPointer />
          </span>
          {subscribeOpen && (
            <form onSubmit={handleSubscribe} style={{
              position: 'absolute',
              top: '40px',
              right: 0,
              background: '#fff',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
              padding: '16px',
              zIndex: 2000,
              minWidth: '260px',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              fontFamily: 'inherit',
            }}>
              <TextField
                type="email"
                label="Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                size="small"
                fullWidth
                autoFocus
                sx={{ fontFamily: 'inherit' }}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
                sx={{ fontWeight: 600, fontFamily: 'inherit' }}
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </Button>
            </form>
          )}
        </div>
      </div>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogContent sx={{ fontFamily: 'inherit', color: modalStatus === 'success' ? '#1a962b' : '#d32f2f', textAlign: 'center', minWidth: 300 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, fontFamily: 'inherit' }}>
            {modalStatus === 'success' ? 'Success' : 'Error'}
          </Typography>
          <Typography sx={{ fontFamily: 'inherit' }}>{modalMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)} color="primary" sx={{ fontFamily: 'inherit' }}>OK</Button>
        </DialogActions>
      </Dialog>
    </nav>
  );
};

export default Navbar;
